import { render, staticRenderFns } from "./TextEllipsis.vue?vue&type=template&id=5a5ab871&scoped=true&functional=true"
import script from "./TextEllipsis.vue?vue&type=script&lang=js"
export * from "./TextEllipsis.vue?vue&type=script&lang=js"
import style0 from "./TextEllipsis.vue?vue&type=style&index=0&id=5a5ab871&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "5a5ab871",
  null
  
)

export default component.exports